<div class="container mt-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h1>Permissões de Acesso</h1>
    <button type="button" class="btn btn-primary" (click)="novoUsuario()">Novo Usuário</button>
  </div>
  <hr />

  <div class="mb-3">
    <div class="input-group">
      <input
        type="text"
        class="form-control"
        placeholder="Pesquisar por nome, usuário ou e-mail..."
        [(ngModel)]="searchTerm"
        (input)="search()"
      />
      <button class="btn btn-outline-secondary" type="button" (click)="search()">Pesquisar</button>
    </div>
  </div>

  <div class="table-responsive">
    <table class="table table-striped table-hover">
      <thead class="thead-dark">
        <tr>
          <th scope="col">ID</th>
          <th scope="col">Usuário</th>
          <th scope="col">Nome Completo</th>
          <th scope="col">E-mail</th>
          <th scope="col" class="text-center">Ativo</th>
          <th scope="col" class="text-center">Ação</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let usuario of paginatedUsuarios">
          <td>{{ usuario.id }}</td>
          <td>{{ usuario.nomeUsuario }}</td>
          <td>{{ usuario.nomeCompleto }}</td>
          <td>{{ usuario.email }}</td>
          <td class="text-center">
            <span class="badge" [ngClass]="usuario.ativo ? 'bg-success' : 'bg-secondary'">
              {{ usuario.ativo ? 'Sim' : 'Não' }}
            </span>
          </td>
          <td class="text-center">
            <div class="d-flex justify-content-center gap-2">
              <button
                type="button"
                class="btn btn-primary btn-sm"
                (click)="gerenciarPermissoes(usuario.id)"
              >
                Gerenciar Permissões
              </button>
              <button
                type="button"
                class="btn btn-warning btn-sm"
                (click)="editarUsuario(usuario.id)"
              >
                Editar
              </button>
              <button
                type="button"
                class="btn btn-danger btn-sm"
                (click)="excluirUsuario(usuario.id)"
              >
                Excluir
              </button>
            </div>
          </td>
        </tr>
        <tr *ngIf="paginatedUsuarios.length === 0">
          <td colspan="6" class="text-center text-muted">Nenhum usuário encontrado.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <app-confirm-dialog
    [isOpen]="confirmDialogAberto"
    title="Excluir Usuário"
    message="Deseja realmente excluir este usuário? Esta ação não pode ser desfeita."
    confirmLabel="Excluir"
    cancelLabel="Cancelar"
    (confirmed)="onConfirmarExclusao()"
    (cancelled)="onCancelarExclusao()"
  ></app-confirm-dialog>

  <nav *ngIf="totalPages > 1" aria-label="Page navigation" class="pagination-container">
    <ul class="pagination justify-content-center">
      <li class="page-item" [class.disabled]="currentPage === 1">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(currentPage - 1)">Anterior</a>
      </li>
      <li
        class="page-item"
        *ngFor="let page of pages"
        [class.active]="page === currentPage"
      >
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(page)">{{ page }}</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(currentPage + 1)">Próxima</a>
      </li>
    </ul>
  </nav>
</div>
